module.exports = __webpack_public_path__ + "static/about-image-1_d-b6e4dc95b269c618234f33b7ea7184df.jpg";